import "../newFooter/footer.css";
import logoImage from "../../assets/images/logo.png";
import { useState } from "react";

const Footer = () => {
  const [socialLinks] = useState({
    facebook: "https://www.facebook.com/crosslinker.usa",
    instagram: "https://www.instagram.com/crosslinker.usa/",
    twitter: "https://x.com/CrosslinkerAi",
    linkedin: "https://www.linkedin.com/in/crosslinker",
    youtube: "https://www.youtube.com/@crosslinker4948/about",
  });

  return (
    <div>
      <footer className="style-8 footer_section pt-5 pb-[50px] bg-[#090817]">
        <div className="container position-relative px-[15px] md:px-[30px] lg:px-[30px]">
          <div className="style-8 footer_section pt-5">
            <div className="links-content">
              <div className="md:flex lg:flex block grid-cols-12 md:space-x-8 lg:space-x-8 space-x-0 gap-4 justify-between">
                <div className="col-span-12 md:col-span-3 lg:col-span-3">
                  <div className="foot-info">
                    <a href="/">
                      <img
                        src={logoImage}
                        alt="logo"
                        height={150}
                        width={220}
                        className="object-fill w-[170px] lg:w-[220px]"
                      />
                    </a>
                    <p className="text-base text-[#ebebeb] mt-8">
                      Global Labs on Cloud{" "}
                      <span className="font-bold text-lg">™</span>
                      <br /> Compliance & Certifications
                    </p>
                    <div className="socials flex mt-8 space-x-4">
                      <svg width="0" height="0" className="absolute pointer-events-none opacity-0">
                        <defs>
                          <linearGradient id="signup-btn-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#f20687" />
                            <stop offset="100%" stopColor="#077ee7" />
                          </linearGradient>
                        </defs>
                      </svg>
                      {socialLinks?.facebook && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={socialLinks.facebook}
                        >
                          <svg
                            stroke="currentColor"
                            fill="url(#signup-btn-gradient)"
                            strokeWidth="0"
                            viewBox="0 0 320 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path>
                          </svg>
                        </a>
                      )}
                      {socialLinks?.instagram && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={socialLinks.instagram}
                        >
                          <svg
                            stroke="currentColor"
                            fill="url(#signup-btn-gradient)"
                            strokeWidth="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M349.33 69.33a93.62 93.62 0 0 1 93.34 93.34v186.66a93.62 93.62 0 0 1-93.34 93.34H162.67a93.62 93.62 0 0 1-93.34-93.34V162.67a93.62 93.62 0 0 1 93.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path>
                            <path d="M377.33 162.67a28 28 0 1 1 28-28 27.94 27.94 0 0 1-28 28zM256 181.33A74.67 74.67 0 1 1 181.33 256 74.75 74.75 0 0 1 256 181.33m0-37.33a112 112 0 1 0 112 112 112 112 0 0 0-112-112z"></path>
                          </svg>
                        </a>
                      )}
                      {socialLinks?.twitter && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={socialLinks.twitter}
                        >
                          <svg
                            stroke="currentColor"
                            fill="url(#signup-btn-gradient)"
                            strokeWidth="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
                          </svg>
                        </a>
                      )}
                      {socialLinks?.linkedin && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={socialLinks.linkedin}
                        >
                          <svg
                            stroke="currentColor"
                            fill="url(#signup-btn-gradient)"
                            strokeWidth="0"
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                          </svg>
                        </a>
                      )}
                      {socialLinks?.youtube && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={socialLinks.youtube}
                          aria-label="YouTube"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            className="w-6 h-[18px]"
                            fill="url(#signup-btn-gradient)"
                          >
                            <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <div id="resourses" className="col-span-3">
                  <div className="links text-[#ebebeb]">
                    <h6 className="footer-title"> Quick Link </h6>
                    <ul>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          Home
                        </a>
                      </li>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us/about-us"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          About
                        </a>
                      </li>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us/blog"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          Blog
                        </a>
                      </li>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us/case-studies"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          Case Studies
                        </a>
                      </li>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us/contact-us"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          Contact
                        </a>
                      </li>
                      <li className="my-4">
                        <a
                          href="https://crosslinker.us/privacy-policy"
                          className="text-[#ebebeb] linkHover transition-colors duration-200"
                        >
                          Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-3">
                  <div className="foot-subscribe">
                    <h6 className="footer-title">Contacts</h6>
                    <div className="max-w-md text-sm text-gray-300">
                      <ul>
                        <li className="flex items-center gap-6 mb-8 leading-6">
                          <span className="inline-flex h-10 w-10 items-center justify-center text-white">
                            <svg
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="#fff"
                              width="40"
                              height="40"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6 22.8787C4.34315 22.8787 3 21.5355 3 19.8787V9.87866C3 9.84477 3.00169 9.81126 3.00498 9.77823H3C3 9.20227 3.2288 8.64989 3.63607 8.24262L9.87868 2.00002C11.0502 0.828445 12.9497 0.828445 14.1213 2.00002L20.3639 8.24264C20.7712 8.6499 21 9.20227 21 9.77823H20.995C20.9983 9.81126 21 9.84477 21 9.87866V19.8787C21 21.5355 19.6569 22.8787 18 22.8787H6ZM12.7071 3.41423L19 9.70713V19.8787C19 20.4309 18.5523 20.8787 18 20.8787H15V15.8787C15 14.2218 13.6569 12.8787 12 12.8787C10.3431 12.8787 9 14.2218 9 15.8787V20.8787H6C5.44772 20.8787 5 20.4309 5 19.8787V9.7072L11.2929 3.41423C11.6834 3.02371 12.3166 3.02371 12.7071 3.41423Z"
                              ></path>
                            </svg>
                          </span>
                          <div>
                            <div className="text-white text-[17.92px] font-medium">
                              Address
                            </div>
                            <div className="text-[17.92px]">
                              5270 California Avenue <br /> Irvine, CA 92697
                            </div>
                          </div>
                        </li>

                        <li className="flex items-center gap-6 mb-8 leading-6">
                          <span className="inline-flex h-10 w-10 items-center justify-center text-white">
                            <svg
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="#fff"
                              width="40"
                              height="40"
                            >
                              <path d="M22 12C22 10.6868 21.7413 9.38647 21.2388 8.1731C20.7362 6.95996 19.9997 5.85742 19.0711 4.92896C18.1425 4.00024 17.0401 3.26367 15.8268 2.76123C14.6136 2.25854 13.3132 2 12 2V4C13.0506 4 14.0909 4.20703 15.0615 4.60889C16.0321 5.01099 16.914 5.60034 17.6569 6.34326C18.3997 7.08594 18.989 7.96802 19.391 8.93848C19.7931 9.90918 20 10.9495 20 12H22Z"></path>
                              <path d="M2 10V5C2 4.44775 2.44772 4 3 4H8C8.55228 4 9 4.44775 9 5V9C9 9.55225 8.55228 10 8 10H6C6 14.4182 9.58173 18 14 18V16C14 15.4478 14.4477 15 15 15H19C19.5523 15 20 15.4478 20 16V21C20 21.5522 19.5523 22 19 22H14C7.37259 22 2 16.6274 2 10Z"></path>
                              <path d="M17.5433 9.70386C17.8448 10.4319 18 11.2122 18 12H16.2C16.2 11.4485 16.0914 10.9023 15.8803 10.3928C15.6692 9.88306 15.3599 9.42017 14.9698 9.03027C14.5798 8.64014 14.1169 8.33081 13.6073 8.11963C13.0977 7.90869 12.5515 7.80005 12 7.80005V6C12.7879 6 13.5681 6.15527 14.2961 6.45679C15.024 6.7583 15.6855 7.2002 16.2426 7.75732C16.7998 8.31445 17.2418 8.97583 17.5433 9.70386Z"></path>
                            </svg>
                          </span>
                          <div>
                            <div className="text-white text-[17.92px] font-medium">
                              Phone
                            </div>
                            <a
                              href="tel:+1.800.365 2131"
                              className="hover:underline linkHover text-[17.92px]"
                            >
                              +1.800.365 2131
                            </a>
                          </div>
                        </li>

                        <li className="flex items-center gap-6 mb-8 leading-6">
                          <span className="inline-flex h-10 w-10 items-center justify-center rounded text-white">
                            <svg
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="#fff"
                              width="40"
                              height="40"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z"
                              ></path>
                            </svg>
                          </span>
                          <div>
                            <div className="text-white text-[17.92px] font-medium">
                              Email
                            </div>
                            <a
                              href="mailto:atul@crosslinker.ai"
                              className="hover:underline linkHover text-[17.92px]"
                            >
                              atul@crosslinker.ai
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="foot pt-4 pb-6 border-1 border-t border-[#0002] text-center">
            <p className="text-sm text-white">
              {new Date().getFullYear()} ©️ All Rights Reserved by{" "}
              <strong className="font-bold text-[#fff]">CROSSLINKER LLC</strong>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
